export interface FundSfdr {
  sfdr: number;
}

export const SfdrArticleValues = {
  article6: 6,
  article8: 8,
  article9: 9,
  noArticle: ''
};

export type Sfdr = (typeof SfdrArticleValues)[keyof typeof SfdrArticleValues];

export type SfdrArticle = { id: Sfdr; text: string };
